import * as rxjs from 'rxjs'

/**
 * Only emits values from the source observable when the given observable is in
 * a `true` state (i.e. the most recently emitted value is `true`)
 *
 * @example
 * // doSomething$:     |---(1)---------(2)------------(3)----------(4)
 * // canDoSomething$:  |-------(true)-------(false)--------(true)
 * // Result:           |---------------(2)-------------------------(4)
 * doSomething$
 *   .pipe(rxjsUtils.onlyWhen(canDoSomething$))
 *   .subscribe(request => execute(request))
 */
export function onlyWhen<T>(
  filter$: rxjs.Observable<boolean>,
): rxjs.MonoTypeOperatorFunction<T> {
  // TODO: this currently only works if `filter$` re-emits the previous value on
  // subscription, which is how many observables function. However, we should
  // refactor to work regardless of that since not all observables function that
  // way
  return rxjs.switchMap(value =>
    filter$.pipe(
      rxjs.filter(canEmit => canEmit),
      rxjs.map(() => value),
    ),
  )
}
